import Stores from './Stores';
import React from 'react';
export default Stores;
